import {
  Box,
  FormControl,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Slide,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useContext, useState } from 'react';
// import { AiOutlineUser } from 'react-icons/ai';
import { FiKey } from 'react-icons/fi';
import Container from '../../../components/Container';
import { PrimaryButton } from '../../../components/CustomButton';
import { AuthContext } from '../../../context/authContext';
import logo from '../logo.png';
import { resetCode } from '../service/resetCode';

export const UpdatePassword = ({ data }) => {
  const [tenantCode, setTenantCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { setIsLoggedin } = useContext(AuthContext);

  const handleLogin = (e) => {
    e.preventDefault();
    // sessionStorage.setItem('tenantPhone', tenantPhone);
    sessionStorage.setItem('tenantCode', tenantCode);
    const payload = {
      newTenantCode: tenantCode,
      userId: data?.data?.userData?.userId,
    };
    console.log(payload);
    resetCode(payload, setLoading, setIsLoggedin);
  };

  return (
    <Slide direction={'right'} in={true} style={{ zIndex: 10 }}>
      <Container>
        <Stack w='100%' as='section' pt='15vh' px='5%'>
          <Box pb='7' align='center'>
            <Image src={logo} alt='logo' height='130px' />
          </Box>
          <Text pb='5' lineHeight={1} fontWeight='500' fontSize='1.5rem'>
            Create New Tenant Code
          </Text>
          <FormControl w='100%'>
            <InputGroup my='7'>
              <Input
                {...inputStyles}
                placeholder='Tenant code'
                value={tenantCode}
                onChange={(e) => setTenantCode(e.target.value)}
              />
              <InputRightElement children={<FiKey />} />
            </InputGroup>
            <PrimaryButton
              loadingText='reseting your code'
              btnText='Create'
              isLoading={loading}
              onClick={handleLogin}
            />
          </FormControl>
        </Stack>
      </Container>
    </Slide>
  );
};

const inputStyles = {
  border: '0',
  size: 'sm',
  borderBottom: '1px solid #ddd',
  pl: '0',
};
